import React from 'react';
import { GamePlayer } from '../../utils';
import PlayerSwitch from '../PlayerSwitch';

import styles from './styles.module.css';

interface PlayerSelectProps {
  selectedPlayer: GamePlayer;
  onPlayerSelected: (player: GamePlayer) => void;
}

const PlayerSelect = (props: PlayerSelectProps) => {
  return (
    <div className={styles['player-mark']}>
      <h4>PICK PLAYER 1’S MARK</h4>
      <PlayerSwitch selectedPlayer={props.selectedPlayer} onPlayerSelected={props.onPlayerSelected} />
      <p>REMEMBER : X GOES FIRST</p>
    </div>
  );
};

export default PlayerSelect;